<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->


<template>
    <v-container>
        <v-row dense>
            <v-col>
                <v-card>
                    <v-card-title class="text-center justify-center py-6">
                        <div class="text-h6 text-sm-h4">{{ language.t('RoadProfiler.CreateTaskInfo.chooseInput') }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            color="blue darken-1"
                            @click="$emit('close');"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="py-6">
                        {{ language.t('RoadProfiler.CreateTaskInfo.createTaskInfo') }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col
                :cols="12"
                :md="6"
            >
                <v-card>
                    <v-card-title class="py-6">
                        <div class="text-h6 text-sm-h4">{{ language.t('RoadProfiler.CreateTaskInfo.titleCurrent') }}
                        </div>
                    </v-card-title>
                    <v-card-text
                        class="py-6"
                        style="min-height: 115px;"
                    >
                        {{ language.t('RoadProfiler.CreateTaskInfo.designModelDescription') }}<br>
                        {{ language.t('RoadProfiler.CreateTaskInfo.surveyModelDescription') }}
                    <!-- - Ontwerp model: getrianguleerd dxf model van het ontwerp.<br>
                            - Inmeting model: getrianguleerd dxf model van de huidige situatie. -->
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="current()"
                            v-if="!$vuetify.breakpoint.xsOnly"
                        >
                            <v-icon>mdi-check</v-icon>{{ language.t('RoadProfiler.CreateTaskInfo.buttonCurrent') }}
                        </v-btn>
                        <v-btn
                            @click="current()"
                            v-else
                        >
                            <v-icon>mdi-check</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col
                :cols="12"
                :md="6"
            >
                <v-card>
                    <v-card-title class="py-6">
                        <div class="text-h6 text-sm-h4">{{ language.t('RoadProfiler.CreateTaskInfo.titleMilling') }}
                        </div>
                    </v-card-title>
                    <v-card-text
                        class="py-6"
                        style="min-height: 115px;"
                    >
                        {{ language.t('RoadProfiler.CreateTaskInfo.designModelDescription') }}<br>
                        {{ language.t('RoadProfiler.CreateTaskInfo.millingModelDescription') }}
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="milling()"
                            v-if="!$vuetify.breakpoint.xsOnly"
                        >
                            <v-icon>mdi-check</v-icon>{{ language.t('RoadProfiler.CreateTaskInfo.buttonMilling') }}
                        </v-btn>
                        <v-btn
                            @click="milling()"
                            v-else
                        >
                            <v-icon>mdi-check</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    components: {
    },
    props: {
    },
    data() {
        return {
        }
    },
    mounted: function () {
    },
    computed: {
    },
    watch: {
    },
    methods: {
        close() {
            this.$emit("close");
        },
        current() {
            console.log("current");
            this.$emit("current");
        },
        milling() {
            this.$emit("milling");
        }
    }
}
</script>
